import PagepartContent from '@molecules/PagepartContent/PagepartContent';
import ClockIcon from '@svg/clock.svg';
import LocationPinIcon from '@svg/location-pin.svg';
import SuitecaseIcon from '@svg/suitcase.svg';
import UserIcon from '@svg/user.svg';
import formatSalary from '@utils/formatSalary';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './VacancyDetails.module.scss';

function Wrapper({ isCompact, children }) {
  if (isCompact) {
    return children;
  }

  return <PagepartContent>{children}</PagepartContent>;
}

Wrapper.propTypes = {
  isCompact: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
};
function VacancyDetails({
  details,
  isCompact,
  isRow,
  hideEducation,
  hideLocation,
  hideSalary,
}) {
  let hours = '';
  let salary = '';

  switch (true) {
    case !!details.minHours && !!details.maxHours:
      hours = `${details.minHours} - ${details.maxHours} uur`;
      break;
    case !!details.minHours && !details.maxHours:
      hours = `${details.minHours} uur`;
      break;
    case !details.minHours && !!details.maxHours:
      hours = `${details.maxHours} uur`;
      break;
    default:
      hours = `Geen specifieke uren.`;
  }

  switch (true) {
    case !!details.minSalary && !!details.maxSalary:
      salary = `${formatSalary(details.minSalary)} - ${formatSalary(
        details.maxSalary
      )}`;
      break;
    case !!details.minSalary && !details.maxSalary:
      salary = `${formatSalary(details.minSalary)}`;
      break;
    case !details.minSalary && !!details.maxSalary:
      salary = `${formatSalary(details.maxSalary)}`;
      break;
    default:
      salary = null;
  }

  return (
    <Wrapper isCompact={isCompact || isRow}>
      <ul
        className={classNames(
          styles.list,
          isCompact && styles.isCompact,
          isRow && styles.isRow
        )}
      >
        <li className={styles.listItem}>
          <ClockIcon className={styles.icon} /> {hours}
        </li>
        {!hideSalary && !!salary && (
          <li className={styles.listItem}>
            <SuitecaseIcon className={styles.icon} />
            {salary}
          </li>
        )}
        {!hideEducation && (
          <li className={styles.listItem}>
            <UserIcon className={styles.icon} />
            {details.education ? details.education : 'Opleiding niet vereist'}
          </li>
        )}
        {!hideLocation && (
          <li className={styles.listItem}>
            <LocationPinIcon className={styles.icon} />
            {details.location ? details.location : 'Geen vaste locatie'}
          </li>
        )}
      </ul>
    </Wrapper>
  );
}

VacancyDetails.propTypes = {
  details: PropTypes.shape({
    minHours: PropTypes.number,
    maxHours: PropTypes.number,
    minSalary: PropTypes.string,
    maxSalary: PropTypes.string,
    education: PropTypes.string,
    location: PropTypes.string,
  }),
  isCompact: PropTypes.bool,
  isRow: PropTypes.bool,
  hideEducation: PropTypes.bool,
  hideLocation: PropTypes.bool,
  hideSalary: PropTypes.bool,
};

export default VacancyDetails;
